import { formatDate, getSelectioAxios, setUser } from '@/main';

export default class LoginService {
    doLogin(username, password) {
        const data = { username: username, password: password, applicationCode: 'selectio' };
        return getSelectioAxios()
            .post('/sso/authenticate', data)
            .then(result => {
                return result.data;
            }).catch(e => {
                setUser(null);
                throw e;
            });
    }

    // refreshJwt(refreshToken) {
    //     return getSelectioAxios()
    //         .post('/sso/refresh-jwt', refreshToken, {
    //             headers: {
    //                 'Content-Type': 'text/plain',
    //             },
    //         })
    //         .then(result => {
    //             return result.data;
    //         });
    // }

    changePassword(user) {
        return getSelectioAxios()
            .post('/sso/password-change', user)
            .then(result => {
                return result.data;
            });
    }

    resetPassword(user) {
        return getSelectioAxios()
            .post('/sso/password-reset', user)
            .then(result => {
                return result.data;
            });
    }

    getUserData() {
        return getSelectioAxios()
            .get('/sso/user-info', {
                headers: {
                    'x-application-code': 'selectio',
                },
            })
            .then(user => {
                return user.data;
            });
    }

    consumeSsoAction(actionId) {
        return getSelectioAxios()
            .get('/sso/action/' + actionId)
            .then(result => {
                return result.data;
            });
    }

    getSsoHomepage() {
        return getSelectioAxios()
            .get('/sso/sso-homepage')
            .then(result => {
                return result.data;
            });
    }

    countPortfolioLoginsByRoleAndCustomerCode(customerCode) {
        return getSelectioAxios()
            .get('/sso/count-portfolio-logins-by-role-and-customerCode/' + customerCode)
            .then(result => {
                return result.data;
            });
    }

    countPortfolioLoginsByRolePeriodAndCustomerCode(customerCode, dateFrom, atDate) {
        const dateFromFormatted = formatDate(dateFrom, 'yyyy-mm-dd');
        const atDateFormatted = formatDate(atDate, 'yyyy-mm-dd');
        return getSelectioAxios()
            .get('/sso/count-portfolio-logins-by-role-period-and-customerCode/' + customerCode + '/dateFrom/' + dateFromFormatted + '/atDate/' + atDateFormatted)
            .then(result => {
                return result.data;
            });
    }

    getListUsersByApplicationAndRole(role, application) {
        return getSelectioAxios()
            .get('/sso/list-users-by-application-and-role/' + role + '/application/' + application)
            .then(result => {
                return result.data;
            });
    }

    lastLoginByPeriodAndCustomerCode(customerCode, dateFrom, atDate) {
        const dateFromFormatted = formatDate(dateFrom, 'yyyy-mm-dd');
        const atDateFormatted = formatDate(atDate, 'yyyy-mm-dd');
        return getSelectioAxios()
            .get('/sso/last-login-by-period-and-customerCode/' + customerCode + '/dateFrom/' + dateFromFormatted + '/atDate/' + atDateFormatted + '/limit/' + 1)
            .then(result => {
                return result.data;
            });
    }

    // GLFP 20250702
    mapUserDataToUser(raw, baseUser) {
        // clono l'oggetto base (username, token, refresh, roles...)
        const user = { ...baseUser };

        // scelgo il profilo "main" se esiste
        const mainProfile = Array.isArray(raw.profiles)
            ? raw.profiles.find(p => p.main)
            : null;

        // campi top-level
        user.email = raw.email;
        user.portfolioList = raw.portfolioList ?? null;

        // codici derivati
        user.companyCode = raw.companyCode ?? mainProfile?.companyCode ?? null;
        user.customerCode = raw.customerCode ?? raw.codiceContraente ?? null;
        user.agencyCode = raw.agencyCode ?? raw.codAge3 ?? null;

        // ruolo da mainProfile.role.code (es. "selectiodir")
        user.role = mainProfile?.role?.code ?? '';

        // flag servizi abilitati
        user.selectioEnabled = Boolean(raw.isSelectioEnabled);
        user.cofastEnabled = Boolean(raw.isCofastEnabled);
        user.lensEnabled = Boolean(raw.isLensEnabled);
        user.databrainEnabled = Boolean(raw.isDatabrainEnabled);

        return user;
    }
}
